<ion-grid class="confirmation-body">
  <ion-row>
    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" *ngIf="moduleName==1">
      <ng-multiselect-dropdown class="ml-5 w-100"
        [placeholder]="'Select Status'"
        [settings]="dropdownSettings" 
        [data]="getStatusList"
        [(ngModel)]="selectedSatus" 
        (onSelect)="onSelectStatus()"
        (onDeSelect)="onDeSelectStatus()"
        (onSelectAll)="selectAllStatus($event)"
        (onDeSelectAll)="onDeSelectAllStatus()">
      </ng-multiselect-dropdown>
    </ion-col>
    <ion-col>
      <div class="center-content justify-content-flex-end">

        <div class="center-content justify-content-flex-end" *ngIf="(moduleName!=1&& moduleName!=4&& moduleName!=2&& moduleName!='Manager')">
          <label class="mr-10" >Rejected</label>
          <mat-slide-toggle class="mr-10"  *ngIf="(moduleName!=1&& moduleName!=4&& moduleName!=2)"[(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
          <label class="mr-10" >Approved</label>
        
        
        </div>
        <button (click)="exportDashboardListExcel()" class="mr-10 Download fs-16 font_semibold">
          <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
        </button>
        <div class="close_bg display-center cp" [mat-dialog-close]>
          <img src="././assets/icon/close_icon.png" class="closeHeight">
        </div>
      </div>
    </ion-col>
  </ion-row>
 
  <!-- Scrollable Table -->
  <ion-row>
    <ion-col class="p-10" size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="table-container">
        
        <table class="table-scroll">
          <thead>
            <tr>
              <th *ngFor="let item of taskColumnHeaderInfoForFinanse" class="fs-14 font_bold cl-black">
                <div class="p-5 verticle-center justify-content-space-between icon-style" [style.width]="item.width">
                  {{ item?.label }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of allTeamMemberReimbursementApprove; let rowId = index">
              <td>{{row.employeeName}}</td>
              <td>{{row.reimbursementType}}</td>
              <td>{{ row.date | date: 'dd-MM-yyyy' }}</td>
                <td>
                  {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                </td>
              <td>{{row.reimbursementLimit}}</td>
              <td>{{row.actualAmount}}</td>
              <td>{{row.assignedAmount}}</td>
              <td>{{row.uploadDocument}}</td>
              <td ><span class="w-70">{{ formatedataVariable(row.status) }}</span></td>
              <td>
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.employeeComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
                </td>
              <td *ngIf="approveMatrixValueForCondition != 'EMPLOYEE_TO_FINANCE'">
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.managerComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
              </td>
              <td>
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.financeComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
              </td>
              <td *ngIf="isApprovedByEnabled">{{row.financeName}}</td>
              <td>{{row.approvedStatus}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
